import * as React from "react";
import {Address as AddressModel} from "../../models/Address";
import {Name} from "../../models/Name";
import {AddressCountry} from "../../models/AddressCountry";
import {AddressState} from "../../models/AddressState";
import {DropDown} from "./DropDown";
import {TextBox} from "./TextBox";
import ISOGeographicStore from "../../stores/ISOGeographicStore";
import update = require("react-addons-update");

export interface AddressEditorProps
{
	fieldName: string;
	tooltip?: string;
	nameOrCompany?: string;
	nameOrCompanyPlaceHolder?: string;
	firstNamePlaceHolder?: string,
	lastNamePlaceHolder?: string,
	firstNameLabel?: string,
	lastNameLabel?: string,
	countryLabel?: string;
	line1Label?: string;
	line2Label?: string;
	line3Label?: string;
	cityLabel?: string;
	stateLabel?: string;
	postalLabel?: string;
	line1PlaceHolder?: string;
	line2PlaceHolder?: string;
	line3PlaceHolder?: string;
	cityPlaceHolder?: string;
	postalPlaceHolder?: string;
	phoneNumberLabel?: string;
	phoneNumberPlaceHolder?: string;
	address?: AddressModel;
	addressUpdated?: (address: AddressModel) => void;
	phoneRequired: boolean;
	shouldTriggerValidation: boolean;
}

export interface AddressEditorState
{
	countries: Array<AddressCountry>;
	states: Array<AddressState>;
	selectedCountry?: AddressCountry;
	selectedState?: AddressState;
	nameOrCompany: string;
	firstName: string;
	lastName: string;
	line1: string;
	line2: string;
	line3: string;
	city: string;
	postalCode: string;
	phoneNumber: string;
}

export class Address extends React.Component<AddressEditorProps, AddressEditorState>
{
	static defaultProps: AddressEditorProps =
	{
		countryLabel: "Country",
		nameOrCompanyPlaceHolder: "Company",
		nameOrCompany: "Company",
		firstNamePlaceHolder: "John",
		lastNamePlaceHolder: "Doe",
		firstNameLabel: "First Name",
		lastNameLabel: "Last Name",
		line1Label: "Street Address",
		line2Label: "Address Line 2",
		line3Label: "Address Line 3",
		cityLabel: " City/Town",
		stateLabel: "State",
		postalLabel: "Postal",
		fieldName: "ChangeThisFieldName",
		line1PlaceHolder: "123 Main Street",
		line2PlaceHolder: "",
		line3PlaceHolder: "",
		cityPlaceHolder: "Anytown",
		postalPlaceHolder: "00000",
		phoneNumberLabel: "Phone Number",
		phoneNumberPlaceHolder: "000-000-0000",
		phoneRequired: true,
		shouldTriggerValidation: false
	};
	state: AddressEditorState =
	{
		countries: [],
		states: [],
		selectedCountry: new AddressCountry(),
		selectedState: new AddressState(),
		firstName: "",
		lastName: "",
		nameOrCompany: "",
		line1: "",
		line2: "",
		line3: "",
		city: "",
		postalCode: "",
		phoneNumber: ""
	}

	componentWillMount(): void
	{
		ISOGeographicStore.addListener(this.geographicStoreChanged.bind(this));
		setTimeout(() =>
			{
				this.setCountry("US");
				this.initAddressData();
			},
			0);
	}

	private initAddressData()
	{
		if (this.props.address)
		{
			const address = this.props.address;
			const country = ISOGeographicStore.findCountryByCode(address.country) || new AddressCountry();
			const state = ISOGeographicStore.findStateByCode(address.country, address.stateProvince) || new AddressState();
			const data =
			{
				selectedCountry: country,
				selectedState: state,
				nameOrCompany: address.nameOrCompany,
				line1: address.line1,
				line2: address.line2,
				line3: address.line3,
				city: address.city,
				postalCode: address.postalCode

			}
			this.setState(update(this.state, { $set: data }));
		}
	}

	render()
	{
		return <div className="newAddressForm">
			       <DropDown
				       items={this.state.countries}
				       value={this.state.selectedCountry.code}
				       onChange={this.countrySelected.bind(this) }
				arrayIsSingleValue={false}
				       itemDisplayName="name"
				       itemValue="code"
				       label={this.props.countryLabel}
				       fieldName={this.props.fieldName + "-address-country"}/>
			       <div className="row">
				       <div className="col-md-6">
					       <TextBox
						       label={this.props.firstNameLabel}
						       value={this.state.firstName}
						       onChange={(ev: React.FormEvent<any>) => { this.updateField("firstName", ev.target.value as string); } }
						       placeholder={this.props.firstNamePlaceHolder}
						       fieldName={this.props.fieldName + "-firstName"}
						       isRequired={this.props.shouldTriggerValidation}
						       requiredMessage={"This field is required"}/>
				       </div>
				       <div className="col-md-6">
					       <TextBox
						       label={this.props.lastNameLabel}
						       value={this.state.lastName}
						       onChange={(ev: React.FormEvent<any>) => { this.updateField("lastName", ev.target.value as string); } }
						       placeholder={this.props.lastNamePlaceHolder}
						       fieldName={this.props.fieldName + "-lastName"}
						       isRequired={this.props.shouldTriggerValidation}
						       requiredMessage={"This field is required"}/>
				       </div>
			       </div>
			       <TextBox
				       label={this.props.nameOrCompany}
				       value={this.state.nameOrCompany}
				       onChange={(ev: React.FormEvent<any>) => { this.updateField("nameOrCompany", ev.target.value as string); } }
				       placeholder={this.props.nameOrCompanyPlaceHolder}
				       fieldName={this.props.fieldName + "-nameOrCompany"}/>
			       <TextBox
				       label={this.props.phoneNumberLabel}
				       value={this.state.phoneNumber}
				       onChange={(ev: React.FormEvent<any>) => { this.updateField("phoneNumber", ev.target.value as string); } }
				       placeholder={this.props.phoneNumberPlaceHolder}
				       fieldName={this.props.fieldName + "-phoneNumber"}
				       isRequired={this.props.phoneRequired && this.props.shouldTriggerValidation}
				       requiredMessage={"This field is required"}/>
			       <TextBox
				       label={this.props.line1Label}
				       value={this.state.line1}
				       onChange={(ev: React.FormEvent<any>) => { this.updateField("line1", ev.target.value as string); } }
				       placeholder={this.props.line1PlaceHolder}
				       fieldName={this.props.fieldName + "-address-line1"}
				       isRequired={this.props.shouldTriggerValidation}
				       requiredMessage={"This field is required"}/>
			       <TextBox
				       label={this.props.line2Label}
				       value={this.state.line2}
				       onChange={(ev: React.FormEvent<any>) => { this.updateField("line2", ev.target.value as string); } }
				       placeholder={this.props.line2PlaceHolder}
				       fieldName={this.props.fieldName + "-address-line2"}/>
			       <TextBox
				       label={this.props.line3Label}
				       value={this.state.line3}
				       onChange={(ev: React.FormEvent<any>) => { this.updateField("line3", ev.target.value as string); } }
				       placeholder={this.props.line3PlaceHolder}
				       fieldName={this.props.fieldName + "-address-line3"}/>
			       <div className="row">
				       <div className="col-md-4">
					       <TextBox
						       label={this.props.cityLabel}
						       value={this.state.city}
						       onChange={(ev: React.FormEvent<any>) => { this.updateField("city", ev.target.value as string); } }
						       placeholder={this.props.cityPlaceHolder}
						       fieldName={this.props.fieldName + "-address-city"}
						       isRequired={this.props.shouldTriggerValidation}
						       requiredMessage={"This field is required"}/>
				       </div>
				       <div className="col-md-4">
					       <DropDown
						       items={this.state.states}
						       onChange={this.stateSelected.bind(this) }
						       pleaseSelectLabel="Please Select"
						       value={this.state.selectedState.code}
						arrayIsSingleValue={false}
						       itemDisplayName="name"
						       itemValue="code"
						       label={this.getStatelabel() }
						       fieldName={this.props.fieldName + "-address-state"}
						       isRequired={this.props.shouldTriggerValidation}
						       requiredMessage={"This field is required"}/>
				       </div>
				       {this.renderPostalCode() }

			       </div>
		       </div>;
	}

	private getStatelabel()
	{
		const country = this.state.selectedCountry;
		if (country)
		{
			return country.stateProvinceLabel;
		}
		return this.props.stateLabel;
	}

	private renderPostalCode()
	{
		const country = this.state.selectedCountry;
		if (country && country.showPostalCode)
		{
			return <div className="col-md-4"> 
				       <TextBox
					       label={this.props.postalLabel}
					       value={this.state.postalCode}
					       onChange={(ev: React.FormEvent<any>) => { this.updateField("postalCode", ev.target.value as string); } }
					       placeholder={this.props.postalPlaceHolder}
					       fieldName={this.props.fieldName + "-address-postal"}
					       isRequired={this.props.shouldTriggerValidation}
					       requiredMessage={"This field is required"}/>
			       </div>;
		}
		return null;
	}

	private countrySelected(ev: React.FormEvent<any>)
	{
		const selectedCountryCode = ev.target.value as string;
		this.setCountry(selectedCountryCode);
	}

	private stateSelected(ev: React.FormEvent<any>)
	{
		const selectedState = ev.target.value as string;
		this.setState(update(this.state,
			{ $set: { selectedState: ISOGeographicStore.findStateByCode(this.state.selectedCountry.code, selectedState) } }));
		this.updateParent();
	}

	private setCountry(countryCode: string)
	{
		this.setState(update(this.state, { $set: { selectedCountry: ISOGeographicStore.findCountryByCode(countryCode) } }));
		setTimeout(() =>
			{
				this.geographicStoreChanged();
				this.updateParent();
			},
			0);
	}

	private geographicStoreChanged()
	{
		const countries = ISOGeographicStore.getCountries();
		this.setState(update(this.state, { $set: { countries: countries } }));
		if (this.state.selectedCountry)
		{
			const states = ISOGeographicStore.getStates(this.state.selectedCountry.code) || [];
			this.setState(update(this.state, { $set: { states: states } }));
		}
	}

	updateField(field: string, value: string): any
	{
		const data: { [prop: string]: string } = {};
		data[field] = value;
		this.setState(update(this.state, { $set: data }));
		this.updateParent();
	}

	private updateParent()
	{
		setTimeout(() =>
			{
				if (this.props.addressUpdated)
				{
					this.props.addressUpdated(this.buildAddressFromState());
				};
			},
			0);
	}

	buildAddressFromState(): AddressModel
	{
		const state = this.state;
		const address = new AddressModel();
		if (address.person === null || address.person !== undefined)
		{
			address.person = new Name();
		}
		address.person.first = state.firstName;
		address.person.last = state.lastName;
		address.nameOrCompany = state.nameOrCompany;
		address.line1 = state.line1;
		address.line2 = state.line2;
		address.line3 = state.line3;
		address.city = state.city;
		address.postalCode = state.postalCode;
		address.country = state.selectedCountry.code;
		address.stateProvince = state.selectedState.code;
		address.phoneNumber = state.phoneNumber;
		return address;
	}
}


// WEBPACK FOOTER //
// ./src/components/common/Address.tsx